// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scan-tube-message {\n  font-weight: 600;\n  font-size: 1.2rem;\n}", ""]);
// Exports
module.exports = exports;
